import { z } from "zod";
import { WineIdentity } from "./wine.js";

export const AddCellarItemRequest = z.object({
  wineId: z.string().min(1).optional(),
  wine: WineIdentity.optional(),
  quantity: z.number().int().min(1).max(999).default(1),
  location: z.string().max(120).default(""),
  drinkFromYear: z.number().int().min(1900).max(2100).optional(),
  drinkByYear: z.number().int().min(1900).max(2100).optional(),
});
export type AddCellarItemRequest = z.infer<typeof AddCellarItemRequest>;

/** `PATCH /v1/cellar/:id` — every field optional; `consume: true` decrements
 * quantity by one (deleting the row at zero), matching the design canvas's
 * "Dronken" action being a quantity step, not a separate ledger. */
export const UpdateCellarItemRequest = z.object({
  quantity: z.number().int().min(0).max(999).optional(),
  location: z.string().max(120).optional(),
  drinkFromYear: z.number().int().min(1900).max(2100).nullable().optional(),
  drinkByYear: z.number().int().min(1900).max(2100).nullable().optional(),
  labelPrinted: z.boolean().optional(),
  consume: z.boolean().optional(),
});
export type UpdateCellarItemRequest = z.infer<typeof UpdateCellarItemRequest>;

export const CellarItem = z.object({
  id: z.string().min(1),
  wine: WineIdentity,
  quantity: z.number().int().nonnegative(),
  location: z.string(),
  drinkFromYear: z.number().int().nullable(),
  drinkByYear: z.number().int().nullable(),
  labelPrinted: z.boolean(),
  addedAt: z.string().datetime(),
});
export type CellarItem = z.infer<typeof CellarItem>;

export const ListCellarResponse = z.object({
  items: z.array(CellarItem),
  total: z.number().int().nonnegative(),
});
export type ListCellarResponse = z.infer<typeof ListCellarResponse>;
